import { render } from "./SupportHome.vue?vue&type=template&id=61adb3ee"
import script from "./SupportHome.vue?vue&type=script&lang=js"
export * from "./SupportHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__